export default __webpack_public_path__ + "static/src/assets/images/icons/bg_nodata.png";